import styled, { createGlobalStyle } from "styled-components";
import { Typography } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import SbTable from "uiCore/SbTable/SbTable";

// Scoped override for this drawer's title font size only
export const DrawerTitleStyle = createGlobalStyle`
  .sb-source-files-drawer .ant-drawer-title {
    font-size: 20px;
  }
  .sb-source-files-drawer .ant-drawer-header {
    padding: 20px 24px;
    min-height: 72px;
    align-items: center;
  }
  .sb-delete-confirm .ant-btn-default:hover {
    border-color: ${({ theme }) => theme.colors.primary} !important;
    color:  ${({ theme }) => theme.colors.primary};
  }
  .sb-source-files-drawer .ant-upload-drag {
    min-height: 160px;
  }
  .sb-source-files-drawer .ant-upload-btn {
    display: flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 160px;
  }
`;

export const FileNameLink = styled.span`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primary};
`;

export const DeleteIcon = styled(DeleteOutlined)`
  color: #8f95b2;
`;

export const FilesTable = styled(SbTable)`
  margin-bottom: 32px;
`;

export const ErrorMessage = styled(Typography.Text)`
  display: block;
  margin-bottom: 16px;
`;

export const UploadSectionTitle = styled(Typography.Title)`
  && {
    margin-bottom: 8px;
  }
`;

export const UploadDescription = styled(Typography.Paragraph)`
  && {
    margin-bottom: 16px;
  }
`;

export const UploadRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: stretch;
`;

export const DropZone = styled.div`
  flex: 1;
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  padding: 32px 16px;
  text-align: center;
  background: #fafafa;
  position: relative;
  cursor: pointer;
`;

export const DraggerWrapper = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;

  .ant-upload-drag {
    height: 100%;
  }
`;

export const UploadActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  min-width: 180px;
`;

